import React from "react";
import { Step, Stepper, StepLabel, StepContent } from "material-ui/Stepper";
import AppBar from "material-ui/AppBar";
import CircularProgress from "material-ui/CircularProgress";
import BackButton from "material-ui/svg-icons/navigation/arrow-back";
import IconButton from "material-ui/IconButton";

import fetchClient from "../../components/utils/fetchClient";

import withAuth from "../../components/auth/withAuth";

import PrepForm from "../../components/precheckin/PrepForm";
import KeyForm from "../../components/precheckin/KeyForm";
import StatusForm from "../../components/precheckin/StatusForm";

import { load as loadPrecheckin } from "../../components/reducers/precheckin";

import { connect } from "react-redux";

import { reduxForm, arrayPush, change } from "redux-form";

class PreCheckIn extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            hasAction: true,
            currentAction: "Loading...",
            booking: [],
            page: 0
        };

        this.handleGoBack = this.handleGoBack.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
    }

    handleGoBack() {
        this.props.history.push("/");
    }

    handleSubmit(values) {
        var self = this;

        fetchClient
            .post("ci/precheckin/" + self.state.booking.refId, values)
            .then(function (response) {
                self.props.history.push("/");
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    handleNext(values) {
        const { page } = this.state;
        if (page < 2) {
            this.setState({ page: page + 1 });
        }

        this.setState({ hasAction: true, currentAction: "Saving changes..." });
        this.updateValues(values);
    }

    handlePrev() {
        const { page } = this.state;
        if (page > 0) {
            this.setState({ page: page - 1 });
        }
    }

    updateValues(values) {
        var self = this;

        fetchClient
            .post("ci/precheckin/" + self.state.booking.refId, values)
            .then(function (response) {
                self.setState({ hasAction: false, currentAction: "" });
                fetchClient
                    .get("ci/precheckin/" + self.state.booking.refId)
                    .then(function (response) {
                        self.setState({ booking: response.data });
                        self.props.load(response.data);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    handleGoBack = () => this.props.history.push("/");

    componentDidMount() {
        var self = this;

        fetchClient
            .get("ci/precheckin/" + self.props.match.params.id)
            .then(function (response) {
                self.setState({ booking: response.data }, () => {
                    self.props.load(response.data);
                    self.setState({ hasAction: false, isLoading: false });
                });
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    render() {
        const { page } = this.state;

        return (
            <div>
                <AppBar
                    title={this.state.hasAction ? this.state.currentAction : "Pre check in for " + this.state.booking.name + ""}
                    iconElementLeft={
                        <IconButton>
                            <BackButton onClick={this.handleGoBack} />
                        </IconButton>
                    }
                />

                {!this.state.isLoading ? (
                    <div>
                        {this.state.booking.propertyGroup === 272 || this.state.booking.propertyGroup === 250 ? ( //h2h and pellaires
                            <Stepper activeStep={page} linear={false} orientation="vertical">
                                <Step>
                                    <StepLabel>Prep</StepLabel>
                                    <StepContent>{page === 0 && <PrepForm onSubmit={values => this.handleNext(values)} />}</StepContent>
                                </Step>

                                <Step>
                                    <StepLabel>Keys</StepLabel>
                                    <StepContent>{page === 1 && <KeyForm previousPage={values => this.handlePrev(values)} onSubmit={values => this.handleNext(values)} />}</StepContent>
                                </Step>

                                <Step>
                                    <StepLabel>Status</StepLabel>
                                    <StepContent>{page === 2 && <StatusForm previousPage={values => this.handlePrev(values)} onSubmit={values => this.handleSubmit(values)} />}</StepContent>
                                </Step>
                            </Stepper>
                        ) : (
                            <Stepper activeStep={page} linear={false} orientation="vertical">
                                <Step>
                                    <StepLabel>Prep</StepLabel>
                                    <StepContent>{page === 0 && <PrepForm onSubmit={values => this.handleNext(values)} />}</StepContent>
                                </Step>

                                <Step>
                                    <StepLabel>Status</StepLabel>
                                    <StepContent>{page === 1 && <StatusForm previousPage={values => this.handlePrev(values)} onSubmit={values => this.handleSubmit(values)} />}</StepContent>
                                </Step>
                            </Stepper>
                        )}
                    </div>
                ) : (
                    <div style={{ paddingLeft: 10 }}>
                        <br />
                        <CircularProgress />
                    </div>
                )}
            </div>
        );
    }
}

PreCheckIn = reduxForm({
    form: "precheckinform",
    destroyOnUnmount: false,
    enableReinitialize: true,
    forceUnregisterOnUnmount: true
})(PreCheckIn);

PreCheckIn = connect(state => ({ initialValues: state.precheckin.data }), { load: loadPrecheckin, arrayPush, change })(PreCheckIn);

export default withAuth(PreCheckIn);
